import { UserMonthlyActivity } from './UserMonthlyActivity';
import { UserNotificationsPreferences } from './UserNotificationPreference';

export enum UserCustomPropertiesKeys {
    userMonthlyActivity = 'userMonthlyActivity',
    userNotificationPreferences = 'userNotificationPreferences',
}

/**
 * Interface of user custom properties to be cached during a session of an app
 */

/**
 * Modified to accommodate notification preferences
 */
export type UserCustomProperties = {
    [UserCustomPropertiesKeys.userMonthlyActivity]?: UserMonthlyActivity;
    [UserCustomPropertiesKeys.userNotificationPreferences]?: UserNotificationsPreferences;
};
